export enum RequestorRoleEnum{
    Employee = "Employee",
    Donor = "Donor",
    ParentOrGuardian = "ParentOrGuardian",
    Other = "Other"
}